export default __webpack_public_path__ + "static/media/sim.5591db24.png";